import * as React from "react";
import { useEnvValue } from "@morningtrain/react-helpers";
import SwiperCore, { Autoplay, EffectFade } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Autoplay, EffectFade]);

export default function ProductSlider() {
  const [selectedVariation] = useEnvValue("selectedVariation");
  const [selectedType] = useEnvValue("selectedType");
  const [types] = useEnvValue("types");

  const getImages = function(){
    if(selectedVariation){
      return {
        image_1: selectedVariation.image_1,
        image_2: selectedVariation.image_2,
      }
    }

    let type = getType()
    if ( type === null ){
      return {};
    }

    return {
      image_1: type.image_1,
      image_2: type.image_2,
    }
  }
  
  const getType = function(){
    let tl = types.length
    for (let i = 0; i < tl; i++) {
      if(types[i].key === selectedType){
        return types[i];
      }
    }
    return null;
  }

  let images = getImages()

  return (
    <Swiper
      className={"mtt-product-gallery__image-wrap"}
      spaceBetween={0}
      slidesPerView={1}
      speed={1000}
      allowTouchMove={false}
      effect={"fade"}
      fadeEffect={{ crossFade: true }}
      autoplay={{
        delay: 8000,
        disableOnInteraction: false
      }}
    >
      {images?.image_1 ? (
        <SwiperSlide>
          <div
            dangerouslySetInnerHTML={{ __html: images?.image_1 }}
          />
        </SwiperSlide>
      ) : null}
      {images?.image_2 ? (
        <SwiperSlide>
          <div
            dangerouslySetInnerHTML={{ __html: images?.image_2 }}
          />
        </SwiperSlide>
      ) : null}
    </Swiper>
  );
}
